module.exports = __webpack_public_path__ + "img/env4.54479e1e.jpg";